export default "__VITE_ASSET__fb761411__"